import { OrganisationPermissionConstants, OrganisationTypeConstants } from "../../../../../../constants";
import { SelectData } from "../../../../../../models";
import { useAuth } from "../../../../../../useAuth";
import { ActionButtons, Column, ErrorBox, InformationBox, Row, Select, TextInput } from "../../../../../../widget";
import { useSendInvitationForm } from "./useSendInvitationForm";

interface SendInvitationFormProps {
  roles: SelectData | undefined;
  rolesInfo: string[];
  userSettingsRoute: string;
}

export const SendInvitationForm = ({ roles, rolesInfo, userSettingsRoute }: SendInvitationFormProps): JSX.Element => {
  const { hasPermission } = useAuth();
  const {
    firstName,
    lastName,
    email,
    role,
    errors,
    isHandleSubmitLoading,
    currentUserType,
    setFirstName,
    setLastName,
    setEmail,
    setRole,
    handleSubmit,
    handleCancel,
  } = useSendInvitationForm(userSettingsRoute);
  const canManageOrganisationUsers = hasPermission(OrganisationPermissionConstants.WRITE_ORGANISATION_USERS);

  return (
    <>
      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={8}>
            <ErrorBox text={errors.map((error) => error.message)} />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleSubmit(e)}>
        <Row spacingV="ll">
          <Column span="4_half">
            <TextInput
              label="First name"
              name="firstName"
              value={firstName}
              disabled={!canManageOrganisationUsers}
              onChange={(value) => setFirstName(value)}
            />
          </Column>
          <Column offset={1} span="4_half">
            <TextInput
              type="email"
              label="Email address"
              name="email"
              value={email}
              disabled={!canManageOrganisationUsers}
              onChange={(value) => setEmail(value)}
            />
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column span="4_half">
            <TextInput
              label="Last name"
              name="lastName"
              value={lastName}
              disabled={!canManageOrganisationUsers}
              onChange={(value) => setLastName(value)}
            />
          </Column>
          {roles && (
            <Column offset={1} span="4_half">
              <Select
                label="Role"
                initialKey={role}
                data={roles}
                onChange={(value) => setRole(value)}
                corners={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "rounded" : "default"}
                disabled={!canManageOrganisationUsers}
              />
            </Column>
          )}
        </Row>
        <Row spacingV="xl">
          <Column span={12}>
            <InformationBox
              variant="info"
              title="What can each role do?"
              corners={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "rounded" : "default"}
            >
              <ul>
                {rolesInfo.map((info, index) => (
                  <div key={info}>
                    <li>{info}</li>
                    {index !== rolesInfo.length - 1 && <br />}
                  </div>
                ))}
              </ul>
            </InformationBox>
          </Column>
        </Row>
        {canManageOrganisationUsers && (
          <Row>
            <Column span={2}>
              <ActionButtons
                submitButtonLabel="Send Invite"
                onCancel={handleCancel}
                isLoading={isHandleSubmitLoading}
              />
            </Column>
          </Row>
        )}
      </form>
    </>
  );
};
